// @flow

import styled, { css } from 'styled-components';

export const Hide = styled.div`
  ${({ empty }) => empty && css`
    &:empty {
      display: none;
    }
  `}
`;
